import { render, staticRenderFns } from "./WList.vue?vue&type=template&id=452df246&scoped=true&"
import script from "./WList.vue?vue&type=script&lang=js&"
export * from "./WList.vue?vue&type=script&lang=js&"
import style0 from "./WList.vue?vue&type=style&index=0&id=452df246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452df246",
  null
  
)

/* custom blocks */
import block0 from "./WList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
